import useTimeout from '@/core/hooks/useTimeout/useTimeout';

export default useTimeout;
